import * as React from 'react';
import { withStyles } from 'tss-react/mui';

interface IProps {
  keymap: string;
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  global?: boolean;
  ctrl?: boolean;
  alt?: boolean;
  shift?: boolean;
  blurOnHit?: boolean;
  caseSensivite?: boolean;
  children?: React.ReactNode;
  classes?: any;
}

const styles = {
  root: {},
};

export const EDKeybind: React.FC<IProps> = ({
  keymap,
  caseSensivite,
  ctrl,
  alt,
  shift,
  blurOnHit,
  onKeyDown: onKeyDownProp,
  global,
  classes,
  children,
}) => {
  const onKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      let keyPressed = event.key;
      let keymapLocal = keymap;
      if (!caseSensivite) {
        keyPressed = keyPressed?.toLocaleLowerCase();
        keymapLocal = keymapLocal.toLocaleLowerCase();
      }

      if (keymapLocal === keyPressed) {
        let hit = true;

        if (ctrl) {
          hit = event.ctrlKey;
        }

        if (alt) {
          hit = event.altKey;
        }

        if (shift) {
          hit = event.shiftKey;
        }

        if (hit) {
          if (blurOnHit && event.target && (event.target as HTMLElement).blur) {
            (event.target as HTMLElement).blur();
          }
          onKeyDownProp(event);
        }
      }
    },
    [keymap, caseSensivite, ctrl, alt, shift, blurOnHit, onKeyDownProp]
  );

  React.useEffect(() => {
    if (global) {
      const onKeyUp: any = onKeyDown;
      document.addEventListener('keydown', onKeyUp);
      return () => {
        document.removeEventListener('keydown', onKeyUp);
      };
    }
    return undefined;
  }, [global, onKeyDown]);

  if (global) {
    return <>{children}</>;
  }

  return (
    <span onKeyUp={onKeyDown} className={classes.root}>
      {children}
    </span>
  );
};

export default withStyles(EDKeybind, styles);
